import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import clsx from 'clsx';

const linkClass = (isActive) =>
    isActive
        ? 'text-[#41A6D7] flex items-center hover:underline'
        : 'text-gray-600 dark:text-gray-200 flex items-center hover:underline';

const MobileGroup = ({ item, toggleMobileMenu }) => {
    const location = useLocation();
    const childActive = item.children.some((child) => location.pathname === child.to);
    const [open, setOpen] = useState(childActive);

    return (
        <li className="py-1 border-b border-gray-200 dark:border-gray-700">
            <button
                type="button"
                aria-expanded={open}
                onClick={() => setOpen((prev) => !prev)}
                className={clsx(linkClass(childActive), 'w-full justify-between')}
            >
                <span className="flex items-center">
                    <item.icon className="mr-2 w-5 h-5 stroke-[1.5]" />
                    {item.label}
                </span>
                <ChevronDown className={clsx('w-4 h-4 stroke-[1.5] transition-transform', open && 'rotate-180')} />
            </button>
            {open && (
                <ul className="mt-2 ml-6 space-y-2">
                    {item.children.map((child) => (
                        <li key={child.to}>
                            <NavLink to={child.to} onClick={toggleMobileMenu} className={({ isActive }) => linkClass(isActive)}>
                                <child.icon className="mr-2 w-4 h-4 stroke-[1.5]" />
                                {child.label}
                            </NavLink>
                        </li>
                    ))}
                </ul>
            )}
        </li>
    );
};

const TopMenuMobile = ({ items, toggleMobileMenu, loginTo, loginLabel, LoginIcon }) => {
    return (
        <div className="flex bg-white dark:bg-gray-800 h-full items-center justify-center">
            <ul className="flex bg-gray-100 dark:bg-gray-800 w-full flex-col font-medium mt-0 px-10 py-10 text-lg">
                {items.map((item, index) =>
                    item.children ? (
                        <MobileGroup key={item.id || item.label} item={item} toggleMobileMenu={toggleMobileMenu} />
                    ) : (
                        <li key={item.to || index} className="py-1 border-b border-gray-200 dark:border-gray-700">
                            <NavLink to={item.to} onClick={toggleMobileMenu} className={({ isActive }) => linkClass(isActive)}>
                                <item.icon className="mr-2 w-5 h-5 stroke-[1.5]" />
                                {item.label}
                            </NavLink>
                        </li>
                    )
                )}
                {loginTo ? (
                    <li className="pt-6">
                        <NavLink
                            to={loginTo}
                            onClick={toggleMobileMenu}
                            className="inline-flex items-center justify-center w-full text-white bg-[#41A6D7] hover:bg-[#3590BA] dark:bg-[#256B8A] dark:hover:bg-[#1E5A77] font-medium rounded-lg text-base px-5 py-2.5"
                        >
                            {LoginIcon ? <LoginIcon className="mr-2 w-5 h-5 stroke-[1.5]" /> : null}
                            {loginLabel}
                        </NavLink>
                    </li>
                ) : null}
            </ul>
        </div>
    );
};

export default TopMenuMobile;
